// wraper to Grid
export default class GridWrapper {
    // mc
    constructor(mc, id = null) {
        this.mc = mc;
        this.viewStateId = null;
        if (id == null) {
            id = "GridWrapper" + GridWrapper._sequence++;
        }
        GridWrapper._store[id] = this;
        this.id = id;
        this.mc.attr("id", id);
        this.swidget = null;
        this._data = null;
        this.resizing = false;
        // filtro
        this.mcFilterText = null;
        this.isFilterLive = true;
        this.filter = null;

        // PARAMETRI RUNTIME
        this._state = {
            p: -1,    // page
            s: {},  // sort
            t: null,   // text,
            a: null // additional args
        }
    }

    get data() {
        if (this._data != null) {
            return this._data;
        }
        try {
            return this.swidget.dataSource.data;
        } catch (ex) {

        }
    }
    set data(value) {
        this._data = value;
    }

    // https://www.shieldui.com/documentation/datasource/javascript/api/settings/skip
    // https://www.shieldui.com/documentation/grid/javascript/api/settings/paging/page

    getFormat(value) {
        let ret = value;
        const tmp = jQuery("<span>" + ret + "</span>");
        tmp.attr("title", value);
        return tmp.get(0);
    }

    // se passo il datasource metto gli _idx
    create(options, data) {
        for (let i = 0; i < options.columns.length; i++) {
            if (!options.columns[i].format) {
                options.columns[i].format = this.getFormat.bind(this);
            }
        }
        this.data = data;
        this.options = options;
        // setto il datasource
        if (!options.dataSource)
            options.dataSource = {};
        // metto un campo counter
        if (data != null) {
            for (let i = 0; i < data.length; i++) {
                data[i]._idx = i;
                data[i]._garbage = false; // non cancellato
            }
            options.dataSource.data = this.data; //this._data;
        }
        // eventi
        if (!options.events) {
            options.events = {};
        }

        // EVENTI PRE
        try {
            if (!options.events)
                options.events = {};
            options.events.command = this.__onCommand.bind(this);
        } catch (ex) {
        }
        try {
            if (!options.paging.events)
                options.paging.events = {};
            options.paging.events.change = this.__onPaging.bind(this, false);
        } catch (ex) {
        }
        //
        try {
            if (options.dataSource.remote.read) {
                options.dataSource.remote.read.data = this.__onServiceEvents.bind(this, "data");
                options.dataSource.remote.read.complete = this.__onServiceEvents.bind(this, "complete");
                options.dataSource.remote.read.dataFilter = this.__onServiceEvents.bind(this, "dataFilter");
            }
        } catch (ex) {

        }
        // data bound
        options.events.dataBound = this._onDataBound.bind(this);
    }
    __onCommand(e) {
        
        //console.log(e.commandName);
        if (e.commandName == "sort") {
            var column = e.column.field;
            var isDescending = e.desc;
            var unsort = e.unsort;

            if (unsort) {
                delete this._state.s[column];
            }
            else {
                this._state.s = {};
                this._state.s[column] = isDescending;
            }
            // console.log("__onSort " + this._state.s)
            //	e.cancel = true;
            this._viewStateSave(this._state)

        } else if (e.commandName == "dataBound") {
            //debugger;
        }

        if (this.options?.events?.dblclick) {
            let rows = $("tr[role='row']", this.mc);
            for (let row of rows) {
                $(row).off('dblclick');
                $(row).on('dblclick', this.options.events.dblclick);
            }
        }
    }
    __onPaging(ispecial, e) {
        if (ispecial) {
            let mc = $(e.target);
            let page = parseInt(mc.data("page"));
            if (!isNaN(page)) {
                this._state.p = page;
            }
        } else {
            this._state.p = e.currentPage;
        }
        // console.log("__onPaging " + this._state.p)
        this._viewStateSave(this._state);
    }
    __onServiceEvents(op, params) {
        // debugger;
        if (op == "data") {
            var odataParams = {};
            let orderby = "";
            {
                for (let f in this._state.s) {
                    orderby += (orderby == "" ? "" : ", ") + (f + " " + (this._state.s[f] ? "desc" : "asc"));
                }
                odataParams["orderby"] = orderby;
            }
            if (this._state.p > -1) {
                odataParams["skip"] = (this._state.p - 1) * this.options.paging.pageSize;
            } else {
                odataParams["skip"] = 0;
            }
            if (params.take != null) {
                odataParams["top"] = params.take;
            }
            odataParams["filter"] = this._state.t;
            if (this._state.a) {
                //odataParams["filter"] = this._state.t;
                // parametri addizzonali
                for (let k in this._state.a)
                    odataParams["_a_" + k] = this._state.a[k] + "";
            }
            //
            return odataParams;
        } else if (op == "complete") {
            try {
                let d = params.responseJSON;
                if (d.Items)
                    this.data = d.Items;
            } catch (ex) {
            }
            /*
            // NON USATA
            let d = params.responseJSON;
            for (let i = 0; i < d.Items.length; i++) {
              d.Items[i]._idx = i;
              d.Items[i]._garbage = false;
            }
            this.data = data;
            if (d.page != this._state.p && this._state.p > -1) {
              // forzo
              //alert("hh")
              this._state.p = d.page;
              this._viewStateSave(this._state);
              this.swidget.pager.page(this._state.p);
            }
            */
        } else if (op == "dataFilter") {
            try {
                let d = JSON.parse(params);
                for (let i = 0; i < d.Items.length; i++) {
                    d.Items[i]._idx = i;
                    d.Items[i]._garbage = false;
                }
                this.data = d.Items;
                params = JSON.stringify(d);
                if (d.page != this._state.p /*&& this._state.p > -1*/) {
                    // forzo
                    this._state.p = d.page;
                    this._viewStateSave(this._state);
                }
            } catch (ex) {
            }
            return params;
        }
    }

    init(viewStateId) {
        this.viewStateId = viewStateId;
        let stat = null;
        if (this.viewStateId) {
            stat = StateManager.getViewState(this.viewStateId);
            if (stat)
                this._state = stat;
        }
        //
        this.mc.shieldGrid(this.options);
        this.swidget = this.mc.swidget();
        // pagination
        $(".sui-pagination").on("click", this.__onPaging.bind(this, true));
        // bindo
        if (stat)
            this._viewStateBind(stat);

        if (this.options?.events?.dblclick) {
            let rows = $("tr[role='row']", this.mc);
            for (let row of rows) {
                $(row).off('dblclick');
                $(row).on('dblclick', this.options.events.dblclick);
            }
        }

    }


    // prepara un template custom che vogliamo gestire
    prepareColumnTemplate(mcTemplate, callBack) {
        // debugger;
        let mcDiv = mcTemplate.clone();
        let templateNum = GridWrapper._sequence++;
        if (callBack) {
            GridWrapper._store[this.id + "_" + templateNum] = callBack;
        }
        mcDiv.attr("id", this.id + "_" + templateNum + "_{_idx}");
        mcDiv.attr("data-index", "{_idx}");
        let UID = this.id + "/" + templateNum + "/{_idx}";
        let js = "<script>__wlfGridWrapperHandler__('" + UID + "','init')</script>";
        mcDiv.append($(js));
        return mcDiv[0].outerHTML;
    }

    // enableSearch
    enableSearch(mcFilterText, filter, isFilterLive = true) {
        this.mcFilterText = mcFilterText;
        this.filter = filter;
        this.isFilterLive = isFilterLive;
        if (this.isFilterLive)
            this.mcFilterText.on("keyup", this._onGridSearchEvent.bind(this, true, null));
    }

    /*
    enableSearchOnClick(mcFilterText, filter) {
      this.mcFilterText = mcFilterText;
      this.filter = filter;
      this._onGridSearchEvent(true);
    }
    */

    _onDataBound() {
        if (this.resizing)
            return;
        if (!this.swidget || !this.viewStateId)
            return;
        // salto pagina
        try {
            if (this.options.dataSource.remote) {
                //this._initBindForRemote(this._state);
                this._viewStateBind(this._state);
            }
        } catch (ex) {
        }
        //console.log("_onDataBound")
    }

    _viewStateSave(stat) {
        if (!this.swidget || !this.viewStateId)
            return;
        StateManager.setViewState(this.viewStateId, stat);
    }
    _viewStateBind(status) {
        if (!this.swidget /*|| !this.viewStateId*/)
            return;
        // sorto
        try {
            if (!this.options.dataSource.remote) {
                // *** NO REMOTE ***
                // sort
                for (let f in status.s) {
                    this.swidget.sort(f, status.s[f], false);
                }
                // filtro
                if (status.t && this.mcFilterText) {
                    this.mcFilterText.val(status.t);
                    this._onGridSearchEvent(false, null);
                }
                // pager
                if (status.p > -1 && this.swidget.pager) {
                    this.swidget.pager.page(status.p);
                }
            } else {
                // *** NO REMOTE ***
                // sort
                {
                    let headers = $("th[role='columnheader']", this.mc);
                    for (let i = 0; i < headers.length; i++) {
                        let head = $(headers[i]);
                        let field = head.attr("data-field");
                        if (status.s.hasOwnProperty(field)) {
                            let des = status.s[field];
                            head.attr("aria-sort", des ? "descending" : "ascending");
                            $("a", head).removeClass("sui-asc");
                            $("a", head).removeClass("sui-desc");
                            $("a", head).addClass(des ? "sui-desc" : "sui-asc");
                            $("span", $("a", head)).remove();
                            $("a", head).append(des ? "<span class='sui-descending'>▼</span>" : "<span class='sui-ascending'>▲</span>");
                        }
                    }
                    
                    if (this.options?.events?.dblclick) {
                        let rows = $("tr[role='row']", this.mc);
                        for (let row of rows) {
                            $(row).off('dblclick');
                            $(row).on('dblclick', this.options.events.dblclick)
                        }
                    }
                }
                // filtro
                if (status.t && this.mcFilterText) {
                    this.mcFilterText.val(status.t);
                }
                // pager
                {
                    let p = (status.p > -1) ? status.p : 1;
                    this.swidget.dataSource.skip = (p - 1) * this.options.paging.pageSize;
                }
            }
        }
        catch (ex) {

        }

        if (this.options?.events?.dblclick) {
            let rows = $("tr[role='row']", this.mc);
            for (let row of rows) {
                $(row).off('dblclick');
                $(row).on('dblclick', this.options.events.dblclick);
            }
        }
    }

    _onGridSearchEvent(bFull, additionalArgs = null) {
        let value = $.trim(this.mcFilterText.val());
        //console.log(value);
        //
        if (value != "" || additionalArgs) {
            for (let k in this.filter) {
                let arr = this.filter[k];
                for (let item of arr)
                    item.value = value;
            }
            if (bFull) {
                this._state.p = -1;
                this._state.t = value;
                this._state.a = additionalArgs;
                // setto
                if (this.swidget.pager && !this.options.dataSource.remote)
                    this.swidget.pager.first();
            }
            this.swidget.dataSource.filter = this.filter
        } else {
            if (bFull) {
                this._state.p = -1;
                this._state.t = null;
                this._state.a = null;
                if (this.swidget.pager && !this.options.dataSource.remote)
                    this.swidget.pager.first();
            }
            //
            this.swidget.dataSource.filter = null;
            /*
            if (this.swidget.pager)
              this.swidget.pager.first();
            */
        }
        // salvo lo status
        if (bFull) {
            this._viewStateSave(this._state);
        }
        // leggo i dati
        this.swidget.dataSource.read();
        //grid.pager.refresh();
    }

    // delete ByDataIndex (deve essere nella view)
    deleteByDataIndex(dataIndex) {
        let rowIndex = this._DataIndex2RelRowIndex(dataIndex);
        if (rowIndex < 0)
            return;
        // setto a _garbage
        try {
            this.data[dataIndex]._garbage = true;
        }
        catch (ex) {
        }
        //
        this.swidget.deleteRow(rowIndex);
        this.swidget.saveChanges();
        if (this.swidget.pager) {
            this.swidget.pager.refresh();
            if (!this.swidget.pager.hasNext())
                this.swidget.pager.last();
        }
    }



    // FUNZIONE DI CONVERSIONE
    /*
    _DataIndex2AbsRowIndex(grid, dataIndex) {
        return ((grid.pager.currentPage - 1) * grid.pager.options.pageSize) + grid.dataSource._indices.indexOf(dataIndex);
    }
    */
    _DataIndex2RelRowIndex(dataIndex) {
        // return this.swidget.dataSource._indices.indexOf(dataIndex);
        for (let i = 0; i < this.swidget.dataSource.view.length; i++)
            if (this.swidget.dataSource.view[i]._idx == dataIndex)
                return i;
        return -1;
    }

    // handler
    __wlfGridWrapperHandler__(UIDsplit, eventId) {
        // debugger;
        //console.log(">> " + UIDsplit + "/" + eventId);
        if (eventId == "init") {
            let templateId = UIDsplit[0] + "_" + UIDsplit[1];
            let dataIndex = parseInt(UIDsplit[2]);
            let rowId = templateId + "_" + dataIndex;
            if (GridWrapper._store[templateId]) {
                GridWrapper._store[templateId]({
                    eventType: "init",
                    gridWrp: this,
                    dataIndex: dataIndex,
                    mcCol: $("#" + rowId),
                    dataRow: this.data[dataIndex]
                });
            }
        }
    }


    setHeight(h) {
        jQuery(".jsList", this.mc).height(h)
        //console.log("setHeight >> " + h);
        return
        //
        this.mc.css('height', h + "px");
        $(".sui-gridcontent", this.mc).css('height', (h - 129.891) + "px");
        $(".sui-content", this.mc).css('height', (h - 129.891) + "px");
        /*
        console.log("setHeight >> " );
        this.resizing = true;
        let stat = this.viewState;
        let options = this.swidget.initialOptions;
        options.height = h;
        // setto il datasource levando quelli cancellati
        if (this.data != null) {
          options.dataSource.data = this.data.filter((x) => x._garbage == false)
        }
        this.swidget.refresh(options);
        this.viewState = stat;
        this.resizing = false;
        */
    }

}

// ********************************************************* //
// COSE INTERNE
// ********************************************************* //

GridWrapper._sequence = 1;
GridWrapper._store = {};
window["__wlfGridWrapperHandler__"] = function (UID, eventId) {
    let tks = UID.split("/");
    if (GridWrapper._store[tks[0]])
        GridWrapper._store[tks[0]]["__wlfGridWrapperHandler__"](tks, eventId);
}
